import { Component, type ReactNode, type ErrorInfo } from 'react';
import { reportError } from '@/services/errors/errorReporter';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    reportError({
      error,
      isHandled: true,
      tags: ['react-error-boundary'],
      sourceFile: info.componentStack ?? undefined,
    });
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        this.props.fallback ?? (
          <div style={{ padding: 16 }}>
            <h3>Une erreur est survenue</h3>
            <p>L'équipe a été notifiée. Rouvrez le panneau ou rechargez Outlook.</p>
          </div>
        )
      );
    }
    return this.props.children;
  }
}
